
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[eventSlug]/engaged",
      function () {
        return require("private-next-pages/events/[eventSlug]/engaged.tsx");
      }
    ]);
  